import FinalSolution from './chromacity-images/MockUpLanding.png';
import React, { useEffect, useRef } from 'react';
import {motion, useInView, useAnimate, useAnimation, useAnimationControls, useScroll, useTransform} from 'framer-motion';


export default function ChromFinalDesign() {
  return (
    <>
    {/* Final Design */}
    <div className='grid grid-cols-12 w-screen h-auto py-10 md:py-20'>
        <div className='md:col-start-3 md:col-end-11 col-start-2 col-end-12'>
        <div className='w-full h-auto space-y-4 md:space-y-6'>
            <motion.h3 initial={{ y:20 ,opacity: 0.2 }} whileInView={{ y:0, opacity: 1, transition: { duration: 1 } }}h3 className='text-left text-4xl md:text-[52px] font-bold text-cyan-950 font-monda tracking-tighter'>Introducing, Chromacity!</motion.h3>
            <ul className='space-y-2 list-disc pl-6'>
                <li className='w-full h-auto font-plus font-medium text-lg text-left'>Created a <span className='font-bold text-cyan-700'>platform allowing users to visually comprehend colour psychology.</span></li>
                <li className='w-full h-auto font-plus font-medium text-lg text-left'>Ensuring the <span className='font-bold text-cyan-700'>platform strictly adheres to professional accessibility guidelines</span> to guarantee it isn’t an overwhelming experience.</li>
                <li className='w-full h-auto font-plus font-medium text-lg text-left'>Providing resources for users to <span className='font-bold text-cyan-700'>further their knowledge in colour psychology,</span> such as the <span className='font-bold text-cyan-700'>Journal Entry feature.</span>
</li>
            </ul>
            <div className='w-full h-auto bg-slate-200 rounded-md overflow-hidden'>
              <img src={FinalSolution} className='w-full'/>
            </div>
        </div>
        </div>
        </div>
    </>
  )
}
